import { Divider, Stack } from '@mui/material';
import React from 'react';
import { SectionCard } from '../../ui/primitives';
import type { LiveSetupStepProps } from './liveSetupStepProps';
import OfferDocumentsList from './OfferDocumentsList';
import OfferDocumentUpload from './OfferDocumentUpload';
import OfferLinkForm from './OfferLinkForm';

/** The offer step's one documents list (finding 35): uploaded PDFs and links, in order. */
export default function OfferDocumentsCard({
  setup,
  setupId,
  readOnly,
  busy,
  session,
  action,
}: Pick<LiveSetupStepProps, 'setup' | 'setupId' | 'readOnly' | 'busy' | 'session' | 'action'>) {
  const api = session.api;
  return (
    <SectionCard title="Offer documents">
      <Stack spacing={2}>
        <OfferDocumentsList
          documents={setup.documents ?? []}
          readOnly={readOnly}
          busy={busy}
          onRename={(documentId, title) =>
            action(() => api.renameOfferDocument(setupId, documentId, title))
          }
          onRemove={(documentId) => action(() => api.removeOfferDocument(setupId, documentId))}
          onReorder={(documentIds) => action(() => api.reorderOfferDocuments(setupId, documentIds))}
        />
        {!readOnly && (
          <>
            <Divider />
            <OfferDocumentUpload
              busy={busy}
              upload={(title, file) => action(() => api.uploadOfferDocument(setupId, title, file))}
            />
            <Divider />
            <OfferLinkForm
              busy={busy}
              add={(title, url) => action(() => api.addOfferLink(setupId, title, url))}
            />
          </>
        )}
      </Stack>
    </SectionCard>
  );
}
